import React from "react";
import { X } from "lucide-react";

function LabelList({ isOpen, onClose, labels, onLabelSelect }) {
  if (!isOpen) return null;

  return (
    <div
      className="absolute top-16 right-6 sm:right-10 md:right-16 bg-[#1e1b4b] text-gray-300 rounded-lg p-4 shadow-xl z-30 w-64 border border-gray-700"
    >
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-yellow-500">Select Category to Assign</h3>
        <button onClick={onClose} className="text-gray-400 hover:text-white">
          <X size={20} />
        </button>
      </div>

      <div className="max-h-[60vh] overflow-y-auto">
        {labels.length === 0 ? (
          <div className="text-center py-6">
            <p className="text-sm text-gray-500">
              No categories available. Create categories first to assign them.
            </p>
          </div>
        ) : (
          <div className="space-y-2">
            {labels.map((label) => (
              <button
                key={label.id}
                onClick={() => onLabelSelect(label)}
                className="w-full flex items-center gap-3 p-3 rounded-lg bg-[#2d2a5a] hover:bg-[#3d3a6a] transition-colors"
              >
                <div
                  className="w-6 h-6 rounded flex-shrink-0"
                  style={{ backgroundColor: label.color }}
                />
                <span className="text-sm text-white">{label.name}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default LabelList;
